import { useEffect } from "react";

import DeletedLeadsTable from "../../components/leads/DeletedLeadsTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function DeletedLeads() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Deleted Leads",
      desc: "View soft-deleted leads and who deleted them",
    });
  }, [setInfo]);

  return <DeletedLeadsTable />;
}
